module.exports = __webpack_public_path__ + "img/kitkitphoto12-768x576.86fbfd9c.jpeg";